const BASE_URL = process.env.REACT_APP_API_BASE_URL;

let authHandlers = null;

export function setAuthHandlers(handlers) {
  authHandlers = handlers;
}

export async function apiFetch(path, { method = 'GET', body, token } = {}, _isRetry = false) {
  const headers = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  // Only set Content-Type when sending a body. Setting it on GETs forces an
  // unnecessary CORS preflight and adds pressure to the browser connection pool.
  if (body !== undefined && body !== null) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: body !== undefined && body !== null ? JSON.stringify(body) : undefined,
  });

  if (response.status === 401 && !_isRetry && authHandlers?.refresh) {
    const newToken = await authHandlers.refresh();
    if (newToken) {
      return apiFetch(path, { method, body, token: newToken }, true);
    }
    // Refresh did not produce a token. If the refresh token itself is dead the
    // auth layer has already signed the user out; anything else (offline, 5xx,
    // throttling) keeps the session and is retried, so surface a plain error
    // instead of dropping an active user at the login screen.
  }

  if (method !== 'GET' && response.status !== 401) {
    // A write is always someone doing something — keep their inactivity clock
    // alive even when the work produces no mouse or keyboard events.
    authHandlers?.onActivity?.();
  }

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const err = new Error(data.error || `Request failed with status ${response.status}`);
    err.code = typeof data.error === 'string' ? data.error : null;
    err.detail = typeof data.message === 'string' ? data.message : null;
    err.status = response.status;
    err.body = data;
    if (data.max_days != null) err.max_days = data.max_days;
    if (data.product_count != null) err.productCount = data.product_count;
    if (data.category_id != null) err.categoryId = data.category_id;
    throw err;
  }

  if (response.status === 204) return null;
  return response.json().catch(() => null);
}
